"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const moment_1 = __importDefault(require("moment"));
const v4_1 = __importDefault(require("uuid/v4"));
const __1 = require("..");
const RealtimeAPI_1 = require("../RealtimeAPI");
class OMObject {
    constructor(arg) {
        this.objectUuid = v4_1.default();
        this.createdAt = moment_1.default();
        this.modifiedAt = moment_1.default();
        this.deletedAt = moment_1.default();
        this.permissions = 700;
        this.isInserted = false;
        this.hasChanges = true;
        this.type = "object";
        if (!arg) {
            return;
        }
        const object = arg;
        this.objectUuid = object.objectUuid || v4_1.default();
        this.title = object.title;
        this.createdAt = moment_1.default(object.createdAt) || moment_1.default();
        this.modifiedAt = moment_1.default(object.modifiedAt) || moment_1.default();
        this.deletedAt = object.deletedAt && moment_1.default(object.deletedAt);
        this.ownerUuid = object.ownerUuid
            ? new __1.OMReference(__1.OMUser, object.ownerUuid)
            : __1.OMUniverse.shared.user && new __1.OMReference(__1.OMUser, __1.OMUniverse.shared.user);
        this.groupUuid = object.groupUuid && new __1.OMReference(__1.OMGroup, object.groupUuid);
        this.parentUuid = object.parentUuid && new __1.OMReference(OMObject, object.parentUuid);
        this.permissions = object.permissions || 700;
        this.isInserted = object.isInserted || false;
        this.slug = object.slug;
        this.type = object.type || this.constructor.Type;
        this.acl = object.acl;
    }
    /* PROPERTIES: OMObjectProtocol */
    get id() { return this.objectUuid; }
    get objectType() {
        return __1.OMUniverse.shared.objectType(this);
    }
    static query() {
        return new __1.OMQuery(this);
    }
    static FromJson(object) {
        return new OMObject(object);
    }
    realtimeSubscription(receiverType) {
        const subscription = new RealtimeAPI_1.OMRealtimeSubscription(receiverType);
        const roomName = `${this.constructor.Path}/${this.id}`;
        subscription.socketRoomName = roomName;
        return subscription;
    }
    getPermissions(user) {
        const currentUser = user || __1.OMUniverse.shared.user;
        switch (true) {
            case this.acl && currentUser && !!this.acl[currentUser.id]:
                return __1.Permissions.from(this.acl[currentUser.id], __1.Role.others);
            case !!(currentUser && this.ownerUuid && currentUser.id === this.ownerUuid.id):
                return __1.Permissions.from(this.permissions, __1.Role.owner);
            // tslint:disable-next-line:max-line-length
            case !!(this.groupUuid && __1.OMUniverse.shared.user.groups.map((group) => group.id).includes(this.groupUuid.id)):
                return __1.Permissions.from(this.permissions, __1.Role.group);
            default:
                return __1.Permissions.from(this.permissions, __1.Role.others);
        }
    }
    /* SECTION: CxUD */
    save() {
        const promise = this.isInserted ? this.update() : this.create();
        return promise
            .then((resp) => __awaiter(this, void 0, void 0, function* () {
            const files = findFiles(this);
            yield Promise.all(files.map((file) => file.upload()));
            return resp;
        }));
    }
    create() {
        try {
            __1.OMUniverse.shared.touch(this);
            const command = new OMObject.Create(this);
            return __1.CommandManager.shared.addToQueue(command)
                .then((response) => {
                this.isInserted = true;
                __1.OMUniverse.shared.touch(this);
                return response;
            });
        }
        catch (error) {
            return Promise.reject(error);
        }
    }
    update() {
        try {
            __1.OMUniverse.shared.touch(this);
            const command = new OMObject.Update(this);
            return __1.CommandManager.shared.addToQueue(command);
        }
        catch (error) {
            return Promise.reject(error);
        }
    }
    delete() {
        try {
            const command = new OMObject.Delete(this);
            return __1.CommandManager.shared.addToQueue(command);
        }
        catch (error) {
            return Promise.reject(error);
        }
    }
}
OMObject.Path = "";
OMObject.Type = "object";
OMObject.Create = class Create extends __1.Command {
    constructor(receiver) {
        super(receiver);
        this.item = receiver;
    }
    execute() {
        return __1.OMUniverse.shared.apiClient.send({
            data: __1.JsonUtils.toJsonApi(this.item),
            method: "POST",
            url: this.typeClass.Path,
        });
    }
};
OMObject.Update = class Update extends __1.Command {
    constructor(receiver) {
        super(receiver);
        this.item = receiver;
    }
    execute() {
        return __1.OMUniverse.shared.apiClient.send({
            data: __1.JsonUtils.toJsonApi(this.item),
            method: "PATCH",
            url: `${this.typeClass.Path}/${this.receiver.actualObject.id}`,
        });
    }
};
OMObject.Delete = class Delete extends __1.Command {
    execute() {
        return __1.OMUniverse.shared.apiClient.send({
            data: __1.JsonUtils.toJsonApi(this.receiver.actualObject),
            method: "DELETE",
            url: `${this.typeClass.Path}/${this.receiver.actualObject.id}`,
        });
    }
};
function findFiles(object, traversed = []) {
    const files = [];
    Object.entries(object).map(([key, value]) => {
        traversed.push(object.id);
        // Steps through direct object's relationships to find OMFile objects
        if (value instanceof __1.OMReference &&
            value.actualObject &&
            !traversed.includes(value.id)) {
            const obj = value.actualObject;
            if (obj && obj.file && value.referencedClazz.prototype instanceof __1.OMFile) {
                files.push(obj);
                traversed.push(obj.id);
            }
            // Steps through each relationship's object to find OMFile objects
            // (caveat, beware of infinite loop)
            // A reference to B, B also reference to A
            files.push(...findFiles(obj, traversed));
        }
        if (Array.isArray(value) &&
            value.length > 0 &&
            value[0] &&
            value[0] instanceof __1.OMReference &&
            value[0].actualObject) {
            const items = value
                .map((item) => item.actualObject)
                .filter((each) => each !== undefined && !traversed.includes(each.id));
            if (value[0] instanceof __1.OMReference &&
                value[0].referencedClazz.prototype instanceof __1.OMFile) {
                files.push(...items.filter((each) => each.file));
                traversed.push(...items.map((each) => each.id));
            }
            // Steps through each relationship's object to find OMFile objects
            // (caveat, beware of infinite loop)
            // A reference to B, B also reference to A
            files.push(...items.flatMap((each) => findFiles(each, traversed)));
        }
    });
    return files;
}
exports.default = OMObject;
//# sourceMappingURL=OMObject.js.map